import React, {Component} from 'react';
import { connect } from 'react-redux';

import SysadminFormsClientAdd from '../../component/sysadmin/forms/client';
import {
    submitSystemAdminCreateClient
} from '../../actions';

class SysadminClientAddPage extends Component {
    render() {
        return (
            <SysadminFormsClientAdd 
                submitSystemAdminCreateClient={this.props.submitSystemAdminCreateClient}
                user={this.props.user}
            />
        );
    }
}

const mapStateToProps = (state) => {
    return {
        user: state.user.user
    }
}

export default connect(mapStateToProps, {
    submitSystemAdminCreateClient
})(SysadminClientAddPage);